import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × PICASSO: Cubist logic — fractured viewpoints made systematic
// Faceted planes, broken perspective, multi-view forms
export function VasarelyPicassoMode({ brand }: ModeRendererProps) {
  return (
    <g>
      {/* Analytical cubist background */}
      <rect x="0" y="0" width="794" height="1123" fill={brand.deep} />

      <g transform="translate(397 540)">
        {/* Fractured plane grid */}
        {Array.from({ length: 16 }).map((_, i) =>
          Array.from({ length: 20 }).map((_, j) => {
            const x = (i - 7.5) * 42;
            const y = (j - 9.5) * 40;
            const fracture = Math.sin(i * 0.6) * 20 + Math.cos(j * 0.5) * 15;
            const angle = Math.atan2(y, x) * 10;
            const colors = [brand.aqua, brand.violet, brand.amber, "#8B7355"];
            const colorIndex = Math.floor((i * j) % 4);
            
            return (
              <path
                key={`${i}-${j}`}
                d={`M ${x + fracture} ${y} L ${x + 18 + fracture} ${y - 8} L ${x + 20} ${y + 12} L ${x + 2} ${y + 20} Z`}
                fill={colors[colorIndex]}
                opacity={0.25}
                transform={`rotate(${angle} ${x} ${y})`}
              />
            );
          })
        )}

        {/* Multi-perspective circles */}
        {Array.from({ length: 8 }).map((_, i) => {
          const angle = (i * Math.PI) / 4;
          const r = 180;
          const x = Math.cos(angle) * r;
          const y = Math.sin(angle) * r;
          
          return (
            <g key={i}>
              {/* Front view */}
              <circle cx={x} cy={y} r="40" fill={brand.aqua} opacity="0.2" />
              {/* Side view */}
              <ellipse cx={x + 15} cy={y - 10} rx="35" ry="45" fill={brand.violet} opacity="0.2" />
              {/* Top view */}
              <ellipse cx={x - 10} cy={y + 15} rx="42" ry="30" fill={brand.amber} opacity="0.2" />
            </g>
          );
        })}

        {/* Broken perspective lines */}
        {Array.from({ length: 24 }).map((_, i) => {
          const angle = (i * Math.PI) / 12;
          const break1 = 80 + Math.sin(i) * 30;
          const break2 = 160 + Math.cos(i) * 40;
          const offset = Math.sin(i * 0.5) * 20;
          
          return (
            <g key={i}>
              <line
                x1="0"
                y1="0"
                x2={Math.cos(angle) * break1}
                y2={Math.sin(angle) * break1}
                stroke={brand.aqua}
                strokeWidth="2"
                opacity="0.3"
              />
              <line
                x1={Math.cos(angle) * break1 + offset}
                y1={Math.sin(angle) * break1}
                x2={Math.cos(angle) * break2 + offset}
                y2={Math.sin(angle) * break2}
                stroke={brand.violet}
                strokeWidth="2"
                opacity="0.25"
              />
            </g>
          );
        })}

        {/* Faceted central form */}
        {[
          { points: "-60,-80 0,-120 60,-80 40,-20 -40,-20", color: brand.aqua },
          { points: "60,-80 100,-40 80,20 40,-20", color: brand.violet },
          { points: "-60,-80 -100,-40 -80,20 -40,-20", color: brand.amber },
          { points: "-40,-20 40,-20 60,40 20,80 -20,80 -60,40", color: brand.aqua },
          { points: "20,80 60,40 100,80 80,140 40,160", color: brand.violet },
          { points: "-20,80 -60,40 -100,80 -80,140 -40,160", color: brand.amber },
        ].map((facet, i) => (
          <polygon
            key={i}
            points={facet.points}
            fill={facet.color}
            opacity="0.25"
            stroke={brand.white}
            strokeWidth="2"
          />
        ))}

        {/* Analytical grid overlay */}
        {Array.from({ length: 12 }).map((_, i) => {
          const r = 60 + i * 20;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke={brand.white}
              strokeWidth="0.5"
              opacity="0.1"
              strokeDasharray="4 4"
            />
          );
        })}

        {/* Cubist viewing nodes */}
        {[
          { x: 0, y: -120 },
          { x: -100, y: -40 },
          { x: 100, y: -40 },
          { x: -100, y: 80 },
          { x: 100, y: 80 },
          { x: 0, y: 140 },
        ].map((node, i) => (
          <g key={i}>
            <circle cx={node.x} cy={node.y} r="8" fill={brand.amber} opacity="0.6" />
            <circle cx={node.x} cy={node.y} r="12" fill="none" stroke={brand.amber} strokeWidth="2" opacity="0.4" />
          </g>
        ))}
      </g>

      {/* Cubist inscription */}
      <text x="397" y="1040" textAnchor="middle" fontFamily="serif" fontSize="11" fill={brand.violet} opacity="0.6" fontStyle="italic">
        perspectiva múltiple
      </text>
    </g>
  );
}
